import { Redirect } from '#app/components/Redirect/index.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useLocation } from '#app/hooks/useLocation.js';
import { useShouldUserOnboard } from '#app/hooks/useShouldUserOnboard.js';
import { appendSearch } from '#app/utilities/appendSearch.js';
import { getRoute } from '@contra/routes';
import { parse } from '@contra/utilities/queryString';

export const Page = () => {
  const currentUser = useCurrentUser();
  const { shouldUserOnboard } = useShouldUserOnboard();
  const isITPPUser = currentUser?.signupSource === 'invite';

  const { pathname, search } = useLocation();

  if (currentUser === null) {
    return (
      <Redirect
        method="push"
        to={appendSearch(getRoute('/sign-up'), parse(search))}
      />
    );
  }

  // If not onboarded and not ITPP user, redirect
  if (shouldUserOnboard() && !isITPPUser) {
    return (
      <Redirect
        method="push"
        to={appendSearch(getRoute('/get-started'), parse(search))}
      />
    );
  }

  return (
    <Redirect
      method="replace"
      to={appendSearch(
        pathname.replace(/^\/me/, '/' + currentUser.profile.displayUsername),
        parse(search),
      )}
    />
  );
};
